import { User } from './user';
// dcc质检结果
export enum FileCheckResult {
  Pass = 'PASS', // 通过
  NotPass = 'NOT_PASS', // 未通过
  NotDetected = 'NOT_DETECTED', // 未检测
  Warning = 'WARNING', // 异常
  Ignore = 'IGNORE', // ( 未提交的质检项&& missing === skip )=> 设置status=‘ignore’
}

export const FileCheckResultName = {
  [FileCheckResult.Pass]: '检测通过',
  [FileCheckResult.NotPass]: '检测未通过',
  [FileCheckResult.NotDetected]: '未检测',
  [FileCheckResult.Warning]: '检测异常',
  [FileCheckResult.Ignore]: '未提交',
};

export const SORT_INDEX = {
  babylon: 1,
  turntable: 1,
  other: 2,
  image: 3,
  video: 2,
  animation: 1,
};
export interface ResolutionType {
  x: number | null;
  y: number | null;
}
export interface FrameRateRecord {
  name: string;
  frames: number;
}
export interface TotalFramesRecord extends FrameRateRecord {
  totalFrames: number; //总帧数
}
export interface FileCheckRuleItem {
  fileName?: string;
  id?: number;
  ruleType: string;
  ruleLabel: string; // 中文 文件大小，面数，贴图依赖
  checkValue?: string | number | boolean | ResolutionType | null;
  checkMethod: string; //计算方式
  checkResult?: string | number | boolean | ResolutionType | FrameRateRecord[];
  checkMessage?: string; //检查结果信息
  status?: FileCheckResult; // 质检结果，在质检完成后才有
  description?: string;
  outputValue?: string;
  isShowRule?: boolean; // 平台配置模版赋值-用户配置的rule为true，平台默认的质检项为false。用途： 1.只质检不输出结果 pass/not_pass 2.是否展示在提交规范
  submitMessage?: string; //提交校验信息
}

export enum FileType {
  MAX = 'max',
  ARP = 'arp',
  JPG = 'jpg',
  PNG = 'png',
  TGA = 'tga',
  ZTL = 'ztl',
  MAYA = 'ma',
  SPP = 'spp',
  FBX = 'fbx',
}

// 平台数据转变：CheckItem => ExportVersionFile
// dcc 根据CheckItem质检，生成质检结果，服务端添加业务信息，生成ExportVersionFile
export type ExportVersionFile = CheckItem & {
  id: string;
  uuid: string;
  fileType: FileType[];
  rules: FileCheckRuleItem[];
  status?: ExportVersionStatus; // 所有文件通过后
  version: ExportVersion['uniqueId']; // 所属版本
  fileUrl?: string | string[]; // 原文件对象存储路径
  exportFileUrl: string | string[]; //转换过的文件存储路径
  exportFileType: ExportFileType[]; //导出的文件类型
  thumbnail?: string; // 预览路径，后续需要变成小图，暂时用exportFileUrl第一张图片
  path?: string;
  fileId?: string;
  errorMsgs?: string[]; // 质检错误信息
};

//正在预览文件的信息
export interface CurrentPreviewFile {
  url: string | string[];
  fileId: string;
  type: ExportFileType;
  loaded: boolean;
}
//文件信息，记录文件id，所在目录路径，文件名
export interface FileItem {
  fileId: string;
  fileName: string;
  path?: string;
}
//导出文件的类型，同PreviewArea预览模式
export enum ExportFileType {
  Image = 'image',
  TurnTable = 'turntable',
  LibraryTurntable = 'libraryTurntable', // 图库模式
  Babylon = 'babylon',
  Null = 'null', //用于进入批注状态
  Other = 'other', //其他不可预览的类型
  Video = 'video',
  Animation = 'animation',
  TurntableVideo = 'turntableVideo', // 旋转展示视频
}
// dcc质检状态
export enum DccStatus {
  Processing = 10,
  Fail = 20,
  Success = 30,
  Timeout = 40, //超时
}
export enum MissingType {
  Error = 'Error',
  Skip = 'Skip',
}
export enum ExportVersionStatus {
  AllStatus = 'ALL_STATUS',
  NotPass = 'NOT_PASS',
  PendingInternal = 'PENDING_INTERNAL_CHECK',
  Pass = 'PASS',
  // Uploading = 'UPLOADING',
  // PendingExternal = 'PENDING_EXTERNAL_CHECK',
  // PendingIterate = 'PENDING_ITERATE',
  // PendingDiscussion = 'PENDING_DISCUSSION',
}

// 导出版本基本信息
export interface ExportVersion {
  uniqueId: number; // 标识
  taskId?: string;
  version: string; // 版本名称/版本号
  status: ExportVersionStatus;
  reviewCount?: number; // 该版本评论数
  preview?: string; // 缩略图
  creator: User; // 提交人
  createTime: string; // 创建/提交时间
  hasNotPassComment: boolean;
  taskSubject?: string; // 所属任务名称
  description?: string; // 版本说明
  fileList?: FileItem[]; //文件元文件信息，路径，名称，id
}
export enum TaskMode {
  Preview, //版本审核
  Edit, //创建批注
}

// dcc质检结果
export interface CheckItem {
  type: string; // 文件类型
  fileName: string;
  itemId?: string; // 与children联用维护规则嵌套关系的标识
  children?: string[]; // 只有type为dcc file这类的包含Group或Material嵌套规则的质检规则有值
  id?: string; // 数据库主键，CRUD使用
  rules?: FileCheckRuleItem[];
  missing?: MissingType;
  warning?: string; //异常提示
  fileName_desc?: string; // 旧数据
  fileNameDesc?: string; // 新数据
  fileType?: string[];
  submitDir?: string;
  name?: string; //只有type为Group或Material有值
  status?: FileCheckResult;
  reason?: string; // EMPTY标记未找到
  isShowRule?: boolean;
}

// 服务端提交文件信息
export interface FileDetail {
  type: string;
  detail: FileCheckRuleItem[];
  name: string;
}
export interface QualityInspection {
  name: string; // 本地质量检查按照默认规则生成的名字
  extra?: Record<string, any>;
  dccVersion?: string;
  projectConfig?: string;
  uuid?: string;
  checkList: ExportVersionFile[];
  status: FileCheckResult;
}
export interface ExportVersionDetail extends ExportVersion {
  title: string;
  downloadUrl?: string; // 该版本的资源文件压缩包下载链接
  projectId: string;
  isCheckPass: boolean; // 整体校验结果
  qualityInspection?: QualityInspection;
  parentTaskId?: number;
  dccStatus?: DccStatus; // dcc质检状态
  uuid?: string; // 质检任务唯一标识
  projectConfig?: string; // 模型预览用的配置
}

export type ExtendFileType = File & {
  format: string;
  key: string;
  path?: string; // 上传文件夹时，文件在文件夹中的相对路径
};
export type NameRule = { reg: string; desc: string; formats: string[] };

export enum SubmitResult {
  Fail = 'FAIL', //打包失败
  Finish = 'FINISH', //打包完成
  Error = 'ERROR', // 质检失败
  Success = 'SUCCESS', // 质检成功
}
export interface SubmitInfo {
  taskSubject: string;
  taskId: number;
  stage: string;
  version: string;
  versionId: number;
}
export interface VersionSubmitResult {
  uuid: string;
  status: SubmitResult; // "FAIL", "FINISH", 这边指的是打包失败或者完成
  info: SubmitInfo; // 提交的版本信息
}
export interface RuleInfoType {
  versionFileType: string[];
  requiredFileNameRules: NameRule[];
  allFileNameRules: NameRule[];
  taskTemplate: CheckItem[];
}
